import { Button, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { useEffect, useReducer, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomMultiSelect from '../../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { createNewBouquet, updateBouquetDetails } from '../../../../../utils/cmsUtils';
import { formDataValidate } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  allFloorsSelector,
  allLocationsSelector,
  allRoomsSelector,
} from '../../../../property/propertySlice';
import { fetchAllBouquets, fetchChannelNumberList } from '../../../cmsSlice';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const BouquetCreate = (props) => {
  const { toggleDrawer, bouquet, hotelId, showLoader = () => {} } = props;
  const [loading, setLoading] = useState(false);
  const locationListData = useSelector(allLocationsSelector);
  const roomListData = useSelector(allRoomsSelector);
  const floorListData = useSelector(allFloorsSelector);
  const [roomList, setRoomList] = useState([]);
  const [roomInFloorList, setRoomInFloorList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [roomSearchValue, setRoomSearchValue] = useState('');
  const [locationSearchValue, setLocationSearchValue] = useState('');
  const [floorSearchValue, setFloorSearchValue] = useState('');
  const [valid, setValid] = useState(false);
  const dispatch = useDispatch();
  const roomListRef = useRef(null);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Bouquet Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Bouquet Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    floor: {
      value: '',
      fieldName: 'Select Floor(s)',
      errors: {},
      validations: [],
      tab: 0,
    },
    room: {
      value: '',
      fieldName: 'Select Room(s)',
      errors: {},
      validations: [],
      tab: 0,
    },
    location: {
      value: '',
      fieldName: 'Select Locations(s)',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    if (bouquet) {
      const currFields = { ...formData };
      for (let field in currFields) {
        if (field === 'floor' || field === 'room' || field === 'location') {
          const idList = [];
          if (bouquet[field] && bouquet[field].length > 0) {
            bouquet[field].forEach((item) => {
              idList.push(item);
            });
          }
          currFields[field].value = idList;
        } else {
          currFields[field].value = bouquet[field];
        }
      }
      setFormData(currFields);
    }
  }, [bouquet]);

  useEffect(() => {
    if (floorListData) setFloorList(floorListData);
  }, [setFloorList, floorListData]);

  useEffect(() => {
    setRoomList([]);
    let roomlist = [];
    if (floorList.length > 0) {
      if (formData['floor']?.value?.length > 0) {
        formData['floor'].value?.forEach((element) => {
          let selectedFloor = floorList?.find((floor) => floor?.name === element);
          roomListData?.forEach((rooms) => {
            selectedFloor?.roomRangeList?.forEach((roomRange) => {
              if (rooms.number >= roomRange?.rangeFrom && rooms?.number <= roomRange?.rangeTo) {
                roomlist?.push(rooms);
              }
            });
          });
        });
        if (formData['room']?.value?.length > 0) {
          formData['room']?.value?.forEach((element) => {
            if (roomlist?.findIndex((room) => room?.number === element) === -1) {
              formData['room'].value = formData['room']?.value?.filter(
                (roomData) => roomData !== element,
              );
            }
          });
        }
         if (roomlist) setRoomList(roomlist);
        setRoomInFloorList(roomlist);
        roomListRef.current = roomlist;
      } else {
        formData['room'].value = [];
        setRoomInFloorList([]);
      }
    }
  }, [setRoomList, roomListData, formData]);

  useEffect(() => {
    if (locationListData) setLocationList(locationListData);
  }, [setLocationList, locationListData]);

 const onSearchRoomList = (searchRoom) => {
    setRoomSearchValue(searchRoom);
    if (!searchRoom) {
      setRoomList(roomInFloorList);
      return;
    }
    const filtered = roomInFloorList?.filter(room =>
      room.number?.toLowerCase().includes(searchRoom?.toLowerCase())
    );
    setRoomList(filtered);
  };

  const RoomRenderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue.map((itemData) => {
      const item = roomListData.find((ild) => ild.number === itemData);
      return item?.number;
    });
    const formItem = { ...formData.room };
    formItem.fieldName = `${selectedValue.length} selected`;
    return <span>{displayName.join(', ')}</span>;
  };

  const LocationRenderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue.map((itemData) => {
      const item = locationListData.find((ild) => ild.name === itemData);
      return item?.name;
    });
    const formItem = { ...formData.location };
    formItem.fieldName = `${selectedValue.length} selected`;
    return <span>{displayName.join(', ')}</span>;
  };

  const onSearchLocationList = async (searchLocation) => {
    setLocationSearchValue(searchLocation);
    if (searchLocation === '') return setLocationList(locationListData);
    const filterList = await locationListData.filter((item) => {
      return item.name.toLowerCase().includes(searchLocation.toLowerCase());
    });
    return setLocationList(filterList);
  };

  const FloorRenderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue.map((itemData) => {
      const item = floorListData.find((ild) => ild.name === itemData);
      return item?.name;
    });
    const formItem = { ...formData.floor };
    formItem.fieldName = `${selectedValue.length} selected`;
    return <span>{displayName.join(', ')}</span>;
  };

  const onSearchFloorList = (searchFloor) => {
    setFloorSearchValue(searchFloor);
    if (searchFloor === '') setLocationList(locationListData);
    const filterList = floorListData.filter((item) => {
      return item.name.toLowerCase().includes(searchFloor.toLowerCase());
    });
    setFloorList(filterList);
  };

  const validate = () => {
    const updatedFields = {};

    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  useEffect(() => {
    setValid(formDataValidate(formData, false));
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      setLoading(true);
      const payload = {};
      let floors = [];
      let locations = [];
      // Populate payload
      for (let field in formData) {
        if (field === 'floor' || field === 'room' || field === 'location') {
          const data = [];
          if (formData[field].value && formData[field].value.length > 0) {
            formData[field].value.forEach((item) => {
              data.push({ name: item });
              if (field === 'floor') {
                floors.push(floorList.find((x) => x.name === item)?.id);
              }
              if (field === 'location') {
                locations.push(locationList.find((x) => x.name === item)?.id);
              }
            });
          }
          payload[field] = data;
        } else {
          payload[field] = formData[field].value;
        }
      }
      payload.floorIDs = floors;
      payload.locationIds = locations;
      try {
        dispatch(stepUpLoaderCount());
        if (bouquet) {
          payload.id = bouquet.id;
          await updateBouquetDetails(payload, hotelId, language);
          notificationManager('success', 'Bouquet updated successfully');
        } else {
          await createNewBouquet(payload, hotelId, language);
          notificationManager('success', 'Bouquet created successfully');
        }

        dispatch(fetchAllBouquets(hotelId));
        dispatch(fetchChannelNumberList(hotelId));
        setLoading(false);
        toggleDrawer('', false, '');
      } catch (error) {
        setLoading(false);
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          bouquet
            ? notificationManager('danger', 'Bouquet updation failed')
            : notificationManager('danger', 'Bouquet creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  return (
    <>
      <form onSubmit={handleSubmit} className='category-create' noValidate>
        <div className='container pt-4 d-flex align-items-end flex-column '>
          <div className='row px-3 w-100 mt-4'>
            <div className='col-md-11'>
              <span className='page-title'>{bouquet ? 'Edit Bouquet' : 'Add Bouquet'}</span>
            </div>
            <div className='col-md-1 d-flex justify-content-end'>
              <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
                <CancelIcon />
              </IconButton>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
            <h4 className='tab-title'>Details</h4>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.name}
                  handleInputChange={(e) => {
                    setFormData({ name: e });
                  }}
                  maxLength={100}
                  endAdornment={true}
                  characterCount={true}
                  multiline={true}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.code}
                  handleInputChange={(e) => {
                    setFormData({ code: e });
                  }}
                  maxLength={8}
                  endAdornment={true}
                  characterCount={true}
                  multiline={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomMultiSelect
                  item={formData.floor}
                  options={floorList}
                  hideNullOption={true}
                  valueField='name'
                  labelField='name'
                  handleInputChange={(e) => setFormData({ floor: e })}
                  isSearchable={true}
                  getSearchInput={onSearchFloorList}
                  searchValue={floorSearchValue}
                  searchPlaceholder='Search'
                  isCustomDisplay={true}
                  renderCustomDisplay={FloorRenderCustomDisplay}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomMultiSelect
                  item={formData.room}
                  options={roomList}
                  hideNullOption={true}
                  valueField='number'
                  labelField='number'
                  handleInputChange={(e) => setFormData({ room: e })}
                  isSearchable={true}
                  getSearchInput={onSearchRoomList}
                  searchValue={roomSearchValue}
                  searchPlaceholder='Search'
                  isCustomDisplay={true}
                  renderCustomDisplay={RoomRenderCustomDisplay}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomMultiSelect
                  item={formData.location}
                  options={locationList}
                  hideNullOption={true}
                  valueField='name'
                  labelField='name'
                  handleInputChange={(e) => setFormData({ location: e })}
                  isSearchable={true}
                  getSearchInput={onSearchLocationList}
                  searchValue={locationSearchValue}
                  searchPlaceholder='Search'
                  isCustomDisplay={true}
                  renderCustomDisplay={LocationRenderCustomDisplay}
                />
              </div>
            </div>
          </div>
          <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
            <div className='col-md-12 d-flex justify-content-start'>
              <Button
                disabled={loading || !valid}
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {bouquet ? 'Update' : 'Add'}
              </Button>
              <Button
                disabled={loading}
                variant='outlined'
                type='button'
                color='secondary'
                size='large'
                onClick={(e) => onCancel(e)}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default BouquetCreate;
